import { ADD_FILE, CHANGE_FILE_SELECTION, REMOVE_FILE } from './reducers';

const actions = dispatch => ({
  addFiles(files, callback, multiple = false) {
    if (!files) {
      throw new Error('files are required');
    }

    if (!Array.isArray(files)) {
      throw new Error('files must be an array of files');
    }

    dispatch({
      type: ADD_FILE,
      files,
      callback,
      multiple
    });
  },
  removeFile(file, callback) {
    if (!file) {
      throw new Error('File is required');
    }

    dispatch({
      type: REMOVE_FILE,
      fileToBeRemoved: file,
      callback
    });
  },
  changeFile(fileIndex, callback) {
    if (fileIndex === undefined) {
      throw new Error('File index to be selected is required');
    }

    dispatch({
      type: CHANGE_FILE_SELECTION,
      selectedFileIndex: fileIndex,
      callback
    });
  }
});

export default actions;
